<div class="wrapper">
  <h1>Changelog</h1>

  <div class="change" appAnchor="v2019.02.01">
    <h2>v2019.02.01</h2>
    <div class="date">16 August 2019</div>
    <h3>New Features:</h3>
    <ul>
      <li>
        This update brings significant performance improvements! This is brought about both because of
        <a href="https://intellij-rust.github.io/2019/08/12/changelog-103.html">IntelliJ-Rust's new cache system</a>
        and a reworking of Intellij-RON's type-checking system.
      </li>
      <li>
        Added support for <a href="https://intellij-rust.github.io/2019/08/12/changelog-103.html">IntelliJ-Rust Update #103</a>.
      </li>
    </ul>
    <h3>Bug Fixes:</h3>
    <ul>
      <li>
        Fixes <a href="https://github.com/vultix/intellij-ron-plugin/issues/3">Issue #3</a> where
        the auto-importer would crash for some users depending on the path they were trying to import from.
      </li>
    </ul>
    <h3>Breaking Changes:</h3>
    <ul>
      <li>
        This version of the IntelliJ-RON plugin drops support for <code>IntelliJ 2018</code>.
        Please update to <code>IntelliJ 2019.1</code> or <code>IntelliJ 2019.2</code> to continue using Intellij-RON.
      </li>
    </ul>

  </div>

  <div class="change" appAnchor="v2019.01.05">
    <h2>v2019.01.05</h2>
    <div class="date">22 July 2019</div>
    <h3>New Features:</h3>
    <ul>
      <li>
        Added support for -inf, inf, and NaN for floats.
      </li>
      <li>
        Added support for <a href="https://intellij-rust.github.io/2019/07/22/changelog-102.html">IntelliJ-Rust Update #102</a>.
      </li>
    </ul>
  </div>

  <div class="change" appAnchor="v2019.01.04">
    <h2>v2019.01.04</h2>
    <div class="date">8 July 2019</div>
    <h3>New Features:</h3>
    <ul>
      <li>
        Added support for <a href="https://intellij-rust.github.io/2019/07/08/changelog-101.html">IntelliJ-Rust Update #101</a>.
      </li>
    </ul>
  </div>

  <div class="change" appAnchor="v2019.01.03">
    <h2>v2019.01.03</h2>
    <div class="date">28 June 2019</div>
    <h3>New Features:</h3>
    <ul>
      <li>
        Updated the formatter's default trailing comma behavior to match the behavior of <code>rustfmt</code>.
      </li>
    </ul>
    <h3>Bug Fixes:</h3>
    <ul>
      <li>Fixed a bug that cause the RON Code Style settings page to continuously spin.</li>
    </ul>

  </div>

  <div class="change" appAnchor="v2019.01.02">
    <h2>v2019.01.02</h2>
    <div class="date">26 June 2019</div>
    <h3>New Features:</h3>
    <ul>
      <li>Added a new fix that allows adding fields to Rust structs directly from a RON file.</li>
    </ul>
  </div>

  <div class="change" appAnchor="v2019.01.01">
    <h2>v2019.01.01 - First Release!</h2>
    <div class="date">26 June 2019</div>
    <h3>New Features:</h3>
    <ul>
      <li>Importing Rust Types</li>
      <li>Autocompletion</li>
      <li>Validation</li>
      <li>Go to Definition</li>
      <li>Find Usages</li>
      <li>Syntax Highlighting</li>
      <li>And More!</li>
    </ul>
  </div>
</div>
